<template>
  <el-dialog
    custom-class="new_dialog"
    title="修改密码"
    :modelValue="visible"
    @update:modelValue="emit('update:visible', $event)"
    :width="480"
  >
    <el-form
      ref="formRef"
      :model="formData"
      :rules="rules"
      hide-required-asterisk
      :label-width="70"
    >
      <el-form-item label="新密码" prop="password">
        <el-input
          v-model="formData.password"
          type="password"
          autocomplete="off"
          placeholder="请输入密码"
          show-password
        />
      </el-form-item>
      <el-form-item label="确认密码" prop="password2">
        <el-input
          v-model="formData.password2"
          type="password"
          autocomplete="off"
          placeholder="请再次输入密码"
          show-password
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          type="primary"
          @click="submitForm(formRef)"
          :loading="loading"
        >
          确认
        </el-button>
        <el-button @click="emit('update:visible', false)">取消</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, toRefs, reactive } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { index_password } from '@/utils/api'

const store = useStore()
const { state } = store
const { loading } = toRefs(state)

// eslint-disable-next-line
const props = defineProps({
  visible: { type: Boolean, default: false },
})
const { visible } = toRefs(props)
// eslint-disable-next-line
const emit = defineEmits(['update:visible'])

const formRef = ref()
const formData = reactive({
  password: '',
  password2: '',
})
const default_rule = {
  message: '请输入',
}
const password2Validator = (rule, value, callback) => {
  if (formData.password2 === '') {
    return callback(new Error('请输入'))
  }
  if (formData.password !== formData.password2) {
    return callback(new Error('密码不一致'))
  }
  callback()
}
const rules = reactive({
  password: [{ ...default_rule, required: true }],
  password2: [{ validator: password2Validator }],
})
const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      index_password(formData).then(({ data: res }) => {
        ElMessage({
          type: 'success',
          message: res.info,
        })
        emit('update:visible', false)
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}
</script>

<style scoped lang="scss"></style>
